import ILossResults from "@myinnsworth/models/lossResults/ILossResults";
import HttpServiceBase from "../httpServiceBase";
import { IEnumeratedFolder } from "@myinnsworth/models/storage/IEnumeratedFolder";
import { IUploadInstitutionFilesModel } from "./models/IUploadInstitutionFilesModel";
import { IUploadFundFilesModel } from "./models/IUploadFundFilesModel";

class ApplicantHttpService extends HttpServiceBase {
    protected get serviceName(): string { return 'applicant' };

    public async fetchInstitutionLossResults(caseSlug: string, insitutionId: number): Promise<ILossResults> {
        return await this.typedGet<ILossResults>(`${caseSlug}/${insitutionId}/lossResults`);
    }

    public async fetchFundLossResults(caseSlug: string, insitutionId: number, fundId: number): Promise<ILossResults> {
        return await this.typedGet<ILossResults>(`${caseSlug}/${insitutionId}/${fundId}/lossResults`);
    }

    public async enumerateInstitutionFolder(slug: string, insitutionId: number, folder: string): Promise<IEnumeratedFolder> {
        return await this.typedGet<IEnumeratedFolder>(`${slug}/${insitutionId}/files/enumerate?folder=${folder}`);
    }

    public async enumerateFundFolder(slug: string, insitutionId: number, fundId: number, folder: string): Promise<IEnumeratedFolder> {
        return await this.typedGet<IEnumeratedFolder>(`${slug}/${insitutionId}/${fundId}/files/enumerate?folder=${folder}`);
    }

    public async institutionUpload(model: IUploadInstitutionFilesModel, files: Array<File>): Promise<any> {
        const fd: FormData = new FormData();
        fd.append("Model", JSON.stringify(model));
        
        if(files && files.length > 0) {
            files.forEach((file, i) => {
                fd.append(`file_${i}`, file);
            });
        }

        return await this.formPost(`${model.caseSlug}/${model.institutionId}/files`, fd);
    }

    public async fundUpload(model: IUploadFundFilesModel, files: Array<File>): Promise<any> {
        const fd: FormData = new FormData();
        fd.append("Model", JSON.stringify(model));
        
        if(files && files.length > 0) {
            files.forEach((file, i) => {
                fd.append(`file_${i}`, file);
            });
        }

        return await this.formPost(`${model.caseSlug}/${model.institutionId}/${model.fundId}/files`, fd);
    }
}

const service = new ApplicantHttpService();
export default service;